export * from './CollectionPageContent';
